/**
 * 后台路由（07 开发文档页面表）。
 * M2：builders/notices/submissions/pages/entrances/assets/settings 全功能页。
 */
import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { ChangePasswordPage, LoginPage } from './pages/LoginPage';
import { AdminLayout } from './pages/AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { ForbiddenPage, RequireAuth } from './pages/RequireAuth';
import { SessionProvider } from './lib/session';
import { BuildersListPage, BuilderEditPage } from './pages/BuildersPage';
import { NoticesListPage, NoticeEditPage } from './pages/NoticesPage';
import { SubmissionsListPage, SubmissionDetailPage } from './pages/SubmissionsPage';
import { PagesAdminPage } from './pages/PagesAdminPage';
import { EntrancesPage } from './pages/EntrancesPage';
import { AssetsPage } from './pages/AssetsPage';
import { SettingsPage } from './pages/SettingsPage';
import { ApiKeysPage } from './pages/ApiKeysPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <SessionProvider>
        <Outlet />
      </SessionProvider>
    ),
    children: [
      { index: true, element: <Navigate to='/dashboard' replace /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'change-password', element: <ChangePasswordPage /> },
      {
        element: <RequireAuth />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              { path: 'dashboard', element: <DashboardPage /> },
              { path: 'builders', element: <BuildersListPage /> },
              { path: 'builders/:id', element: <BuilderEditPage /> },
              { path: 'notices', element: <NoticesListPage /> },
              { path: 'notices/:id', element: <NoticeEditPage /> },
              { path: 'submissions', element: <SubmissionsListPage /> },
              { path: 'submissions/:id', element: <SubmissionDetailPage /> },
              { path: 'pages', element: <PagesAdminPage /> },
              { path: 'pages/:key', element: <PagesAdminPage /> },
              { path: 'entrances', element: <EntrancesPage /> },
              { path: 'assets', element: <AssetsPage /> },
              { path: 'settings', element: <SettingsPage /> },
              { path: 'api-keys', element: <ApiKeysPage /> },
            ],
          },
        ],
      },
      { path: 'forbidden', element: <ForbiddenPage /> },
      { path: '*', element: <Navigate to='/dashboard' replace /> },
    ],
  },
]);
